module.exports = __webpack_public_path__ + "static/media/theme-logo.fe88ccf8.svg";